<template>
    <div class="header">
        <i :class="icon"></i>
        <span>
            {{ formparamStr || dataTreeObj.label }}
        </span>
    </div>
</template>

<script>
import bus from '@/utils/bus.js';
export default {
    props: ['defaultTreeObj'],
    data() {
        return {
            iconArray: ['iconfont icon-zuzhijiagou', 'iconfont icon-ditu', 'el-icon-picture'],
            icon: 'iconfont icon-kehu',
            dataTreeObj: {},
            formparamStr: '',
            treeData: []
        };
    },
    mounted() {
        this.dataTreeObj = { ...this.defaultTreeObj };
        console.log(this.dataTreeObj);
        this.getNodeClickTreeFn();
        this.delSuccessFn();
    },
    methods: {
        getNodeClickTreeFn() {
            bus.$on('nodeClickTree', row => {
                this.iconFn(row);
                this.publicFn(row);
            });
        },
        iconFn(data) {
            if (data.level === 0) return (this.icon = 'iconfont icon-kehu');
            //nodeType==2时funcType（0-什么都不关联、1-平面图、2-地图）
            else if (data.nodeType === 2) {
                switch (data.funcType) {
                    case 0: {
                        return (this.icon = 'iconfont icon-zuzhijiagou');
                    }
                    case 1: {
                        return (this.icon = 'el-icon-picture');
                    }
                    case 2: {
                        return (this.icon = 'iconfont icon-ditu');
                    }
                    default:
                        break;
                }
            }
        },
        delSuccessFn() {
            bus.$on('delSuccess', row => {
                this.publicFn(row);
            });
        },
        publicFn(row) {
            let arr = this.$getParent([...this.$store.state.SchemaTree], row.sceneCode, 'sceneCode').map(item => {
                return item.label;
            });
            this.formparamStr = arr.join(',').replace(/,/g, ' / ');
        }
    }
};
</script>

<style lang="scss" scoped>
.header {
    height: 50px;
    width: 100%;
    line-height: 30px;
    border-bottom: 1px solid $borderColor3;
    padding: 10px;
    box-sizing: border-box;
}
</style>
